import { useState } from 'react'
import { Flex } from '@dd3tech/wiggui/Flex'
import { Transition } from '@dd3tech/wiggui/Transition'
import { MdOutlineChevronRight } from 'react-icons/md'
import { composeClasses } from '../../../../utils/src/strings'
import { useLayoutV2Store } from '../../../store/layout-v2.store'
import type { OptionMenu } from '../hooks/useGetMenuOptions'
import './MenuOption.css'
import HardLink from '../../../components/hard-link/HardLink'

interface MenuOptionProps {
  option: OptionMenu
}

export const MenuOption = ({ option }: MenuOptionProps) => {
  const { setIsExpandedMenu, isExpandedMenu } = useLayoutV2Store()

  /*  const someSubOptionIsActive = option?.subOptions?.some(
    (subOption) => subOption?.isActive
  ) */

  const [isExpandedOptions, setIsExpandedOptions] = useState(
    // Boolean(someSubOptionIsActive)
    true
  )

  const hasSubOptions = Boolean(
    option?.subOptions && option?.subOptions?.length > 0
  )

  const showDesktopSubOptions = Boolean(
    isExpandedOptions && isExpandedMenu && hasSubOptions
  )

  const enableIsExpandedMenu = isExpandedMenu
  return (
    <li
      className={composeClasses(
        hasSubOptions && 'flex flex-col items-baseline gap-1 w-full',
        showDesktopSubOptions ? 'h-fit' : 'h-[40px] min-h-[40px]',
        'list-none'
      )}
    >
      <HardLink
        href={option.url!}
        onClick={(event) => {
          event.stopPropagation()
          setIsExpandedMenu(false)
        }}
        className={composeClasses(
          option?.isActive && 'bg-white',
          enableIsExpandedMenu && 'w-full',
          'flex flex-row items-center justify-between gap-3 cursor-pointer rounded-xl hover:bg-[#DEE5F1] min-h-[40px] h-10 px-[10px] active:bg-white group transition-colors duration-300 ease-in-out'
        )}
      >
        <Flex dir="row" items="center" justify="between" gap="gap-3" wFull>
          <Flex dir="row" items="center" justify="start" gap="gap-3" wFull>
            <span
              className={composeClasses(
                'text-primary group-active:font-semibold',
                option?.isActive && 'font-semibold'
              )}
            >
              {option?.icon}
            </span>
            <Transition
              duration={300}
              show={enableIsExpandedMenu}
              className="w-full"
            >
              <p
                className={composeClasses(
                  option?.isActive
                    ? 'text-body-bold-m'
                    : 'text-body-m group-active:text-body-bold-m',
                  'text-primary whitespace-nowrap text-ellipsis overflow-hidden w-full text-left max-w-[90px]'
                )}
              >
                {option?.name}
              </p>
            </Transition>
          </Flex>
        </Flex>
        <Transition
          duration={300}
          show={hasSubOptions && enableIsExpandedMenu}
          className="w-full min-w-[20px] min-h-[20px] max-w-[20px] max-h-[20px]"
        >
          <div
            className="rounded-full  min-w-[20px] min-h-[20px] max-w-[20px] max-h-[20px] flex items-center justify-center hover:bg-[#DEE5F1] active:bg-white hover:brightness-90 active:brightness-110"
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              setIsExpandedOptions(!isExpandedOptions)
            }}
          >
            <MdOutlineChevronRight
              className={composeClasses(
                'min-w-[18px] min-h-[18px] max-w-[18px] max-h-[18px] chevron-icon',
                isExpandedOptions ? 'chevron-icon--expanded' : ''
              )}
            />
          </div>
        </Transition>
      </HardLink>

      <div
        className={composeClasses(
          'suboptions-container w-full',
          showDesktopSubOptions && enableIsExpandedMenu
            ? 'suboptions-container--expanded'
            : 'suboptions-container--collapsed'
        )}
      >
        <ul className="flex flex-col w-full">
          {option?.subOptions?.map((subOption) => {
            return (
              <li key={subOption.id} title={subOption.name}>
                <HardLink
                  href={subOption.url!}
                  onClick={() => {
                    // setIsExpandedOptions(false)
                  }}
                  className={composeClasses(
                    subOption?.isActive && 'bg-white',
                    'flex flex-row items-center justify-start gap-3 w-full px-[10px] py-[6px] rounded-xl hover:bg-[#DEE5F1] active:bg-white group transition-colors duration-300 ease-in-out'
                  )}
                >
                  <div className="h-[18px] w-[18px]" />
                  <p
                    className={composeClasses(
                      subOption?.isActive
                        ? 'text-body-bold-s'
                        : 'text-body-s group-active:text-body-bold-s',
                      'text-primary whitespace-nowrap text-ellipsis overflow-hidden w-full text-left max-w-[110px]'
                    )}
                  >
                    {subOption?.name}
                  </p>
                </HardLink>
              </li>
            )
          })}
        </ul>
      </div>
    </li>
  )
}
